<template>
	<div v-if="message" class="message-item" :class="{incoming:message.type=='incoming', unread:message.type=='incoming' && !message.read}">
        <template v-if="!swapToFrom">
            <div v-if="message.type=='outgoing'" class="message-recipients">
                To:
                <span v-for="recipient in message.recipients" class="message-recipient" :class="{success:recipient.success, failed:!recipient.success}" @click.prevent="getError($event, recipient.message_id, recipient.success)">{{ recipient.name }}</span>
                <span v-if="(!message.recipients || message.recipients.length === 0) && message.to" class="message-recipient" :class="{success:message.to.success, failed:!message.to.success}" @click.prevent="getError($event, message.to.message_id, message.to.success)">{{ message.to.name }} </span>
            </div>
            <div v-if="message.type=='incoming'" class="message-senders">
                From: <span class="message-sender" >{{ message.from.name }}</span>
            </div>
        </template>
        <template v-else>
            <div v-if="message.type=='incoming'" class="message-recipients">
                To:
                <span v-for="recipient in message.recipients" class="message-recipient" :class="{success:recipient.success, failed:!recipient.success}" @click.prevent="getError($event, recipient.message_id, recipient.success)">{{ recipient.name }}</span>
                <span v-if="!message.recipients || message.recipients.length === 0" class="message-recipient" :class="{success:message.to.success, failed:!message.to.success}" @click.prevent="getError($event, message.to.message_id, message.to.success)">{{ message.to.name }} </span>
            </div>
            <div v-if="message.type=='outgoing'" class="message-senders">
                From: <span class="message-sender" >{{ message.from.name }}</span>
            </div>
        </template>

        <div v-if="message.type=='incoming' && !message.read" class="unread-dot"></div>
		{{ message.message }}
		<message-reply-field v-if="message.addReply" :message="message" @sent="alertUpdateGroup" @cancel="cancelReply()" />
		<div v-if="message.type=='incoming'" class="message-controls">
			<button type="button" class="message-control uk-button uk-button-link" @click="addReplyToMessage()"><i class="fas fa-reply"></i> Reply</button>
			<button v-if="!message.read && !hideControls" type="button" class="message-control uk-button uk-button-link" @click="markRead()"><i class="fas fa-book-open"></i> Mark Read</button>
		</div>
		<div v-if="message.replies && message.replies.length > 0" class="replies">
			<message-item v-for="message in message.replies" :key="'msg_'+message.id" :depth="depth+1" @sent="updateUpTheChain" :message="message" :swap-to-from="swapToFrom" :hide-controls="hideControls"></message-item>
		</div>
        <div ref="error_inspector" class="error-inspector" :class="{showing:showError}">
            {{ errorMessage }}
            <button type="button" class="close-btn uk-button uk-button-link" @click="closeError"><i class="fas fa-times"></i></button>
        </div>
	</div>
</template>

<script>
import MessageReplyField from "./MessageReplyField";
export default {
	name: "MessageItem",
	components: {
		MessageReplyField
	},
	props: {
		message:{
			type: Object,
			default: null
		},
		depth: {
			type: Number,
			default: 0
		},
        swapToFrom:{
            type: Boolean,
            default: false
        },
        hideControls:{
            type: Boolean,
            default: false
        }
	},
	data() {
		return {
            showError: false,
            errorMessage: "loading"
        };
	},
	mounted() {

	},
	methods: {
		alertUpdateGroup(){
			this.$emit("sent");
		},
		addReplyToMessage(){
			this.message.addReply = true;
			this.$forceUpdate();
		},
		cancelReply(){
			this.message.addReply = false;
			this.$forceUpdate();
		},
		updateUpTheChain(){
			this.$emit("sent");
		},
        getError(event, id, success){
            if(success){
                return;
            }
            this.$refs.error_inspector.style.top = (event.target.offsetTop - 50) + "px";
            this.$refs.error_inspector.style.left = (event.target.offsetLeft - 12) + "px";
            this.showError = false;
            axios.get("/api/message/error/" + id).then(
                (pack) => this.displayError(pack.data)
            );
        },
        displayError(data){
            if(data.success){
                this.errorMessage = data.data.error;
                this.showError = true;
            } else{
                this.errorMessage = "Reason unavailable.";
                this.showError = true;
            }
        },
        closeError(){
            this.showError = false;
        },
        markRead(){
            this.message.read = true;
            axios.post("/api/message/read/" + this.message.id).then(
                () => this.updateUpTheChain(),
                () => this.updateUpTheChain()
            );
        }
	},
}
</script>
